<template>
  <Row
    class="hi-lo-group-bet-lot-cell"
    :class="{ 'hi-lo-group-bet-lot-cell-active': win, [size]: size }"
    type="flex"
    justify="space-between"
    align="middle"
  >
    <div class="hi-lo-group-bet-lot-title" :class="{ [size]: size }">
      <span v-html="$t(`hi_lo.${type}_trend`)"></span>
    </div>
    <div class="hi-lo-group-bet-lot-bet-no" :class="{ [size]: size }">{{ odd }}</div>
    <div v-if="stakeRecordSum" class="hi-lo-group-bet-lot-stake-total">{{ stakeRecord }}</div>
  </Row>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "win", "game", "size", "stakeRecordSum"],
  components: {
    Row
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    }
  }
};
</script>

<style lang="scss" scoped>
.hi-lo-group-bet-lot-cell {
  width: 100%;
  height: 34px;
  margin-bottom: 5px;
  text-align: center;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  cursor: pointer; //1017 ADDED
}

.hi-lo-group-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.hi-lo-group-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.hi-lo-group-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.hi-lo-group-bet-lot-title {
  color: #5c3926;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  padding: 0 12px 0 5px;
  text-align: center;
  width: 60%;
  height: 34px;
  line-height: 34px;
  background: #edba35;
  background: -moz-linear-gradient(left, #fce569 0%, #edba35 100%);
  background: -webkit-linear-gradient(left, #fce569 0%, #edba35 100%);
  background: linear-gradient(to right, #fce569 0%, #edba35 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fce569', endColorstr='#edba35',GradientType=1 );

  border-radius: 5px 0 0 5px;
  position: relative;
}

.hi-lo-group-bet-lot-title:after {
  content: "";
  border-top: 17px solid transparent;
  border-left: 6px solid transparent;
  border-right: 6px solid #2a2a2b;
  border-bottom: 17px solid #2a2a2b;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 34px;
  width: 12px;
}

.hi-lo-group-bet-lot-title.small {
  height: unset;
  margin-top: 5px;
}

.hi-lo-group-bet-lot-bet-no {
  margin-top: 0px;
  font-size: 12px;
  color: #fff;
  width: 40%;
  height: 34px;
  line-height: 34px;
  background: #2a2a2b;
  position: relative;
  text-align: left;
  padding-left: 5px;
  border-radius: 0 5px 5px 0;
}

.hi-lo-group-bet-lot-bet-no.small {
  height: unset;
}

.hi-lo-group-bet-lot-cell-active .hi-lo-group-bet-lot-title,
.hi-lo-group-bet-lot-cell-active .hi-lo-group-bet-lot-bet-no {
  @extend .tai-xiu-game-btn-active;
}
</style>
<style lang="scss">
.hi-lo-group-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}
</style>
